import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {LandingPageComponent} from '../../../landing/containers/landing-page/landing-page.component';
import {CollectionPageComponent} from '../../../products/containers/collection-page/collection-page.component';
import {LoginPageComponent} from '../../../user/containers/login-page/login-page.component';
import {ContentPageComponent} from '../../containers/content-page/content-page.component';
import {LanguageService} from '../../services/language.service';
import {ContactComponent} from '../../containers/contact/contact.component';
import '../../../shared/components/navigable';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {Language} from '../../models/language';
import {FormControl, FormGroup} from '@angular/forms';
import {DownloadComponent} from "../../containers/download/download.component";

@Component({
    selector: 'app-site-menu',
    templateUrl: './site-menu.component.html',
    styleUrls: ['./site-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteMenuComponent {
    @Output()
    closeSiteMenu = new EventEmitter();

    @Input()
    isLoggedIn$: Observable<boolean>;

    @Input()
    activatedComponent: object;

    @Input()
    languages: Language[];

    @Input()
    currentLanguage: Language;

    @Output()
    languageSwitched = new EventEmitter<Language>();

    @Output()
    loggedOut = new EventEmitter();

    @Output()
    search = new EventEmitter<string>();

    constructor(
        private languageService: LanguageService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon(
            'hering-search',
            this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/header/search.svg')
        );
    }

    form: FormGroup = new FormGroup({
        searchText: new FormControl('')
    });

    isLoginPageShown(): boolean {
        return this.activatedComponentIs(LoginPageComponent.COMPONENT_ID);
    }

    isDownloadShown(): boolean {
        return this.activatedComponentIs(DownloadComponent.COMPONENT_ID);
    }

    isCategoriesPageShown(): boolean {
        return this.activatedComponentIs(LandingPageComponent.COMPONENT_ID);
    }

    isProductCollectionPageShown(): boolean {
        return this.activatedComponentIs(CollectionPageComponent.COMPONENT_ID);
    }

    isContactPageShown(): boolean {
        return this.activatedComponentIs(ContactComponent.COMPONENT_ID);
    }

    getB2cShopLink(): string {
        if (this.languageService.getCurrentLanguage().href === 'de') {
            return environment.b2c_shop_german;
        }
        return environment.b2c_shop_english;
    }

    private activatedComponentIs(id: string): boolean {
        if (this.activatedComponent == null || (this.activatedComponent as Navigable).getId === undefined) {
            return false;
        }

        return (this.activatedComponent as Navigable).getId() === id;
    }

    onCloseSiteMenu() {
        this.closeSiteMenu.emit();
    }

    logout() {
        this.loggedOut.emit();
    }

    submitSearch() {
        const searchText = this.form.get('searchText').value;

        this.search.emit(searchText);
        this.onCloseSiteMenu();
    }

    switchLanguage(language: Language) {
        this.languageSwitched.emit(language);
    }
}
